(function () {
    let overrideInstalled = false;

    function installOverride() {
        if (overrideInstalled) return;

        if (window.tlFreeGiftOffer && typeof window.tlFreeGiftOffer.detectCartData === 'function') {
            overrideInstalled = true;
            
            window.tlFreeGiftOffer.detectCartData = async function () {
                try {
                    const cartData = await this.ajaxApi.cartGet();

                    const itemsInCart = new Map();
                    const ruleIdMapGifts = new Map();
                    if (cartData.items.length) {
                        const validItem = cartData.items.find(item => !isNaN(item.price / item.presentment_price));
                        const ratio = validItem ? validItem.price / validItem.presentment_price : 1;

                        for (let i = 0; i < cartData.items.length; i++) {
                            const item = cartData.items[i];
                            const itemKey = item.key;
                            const itemId = String(item.id);
                            const productId = String(item.product_id);

                            const appliedRuleId = this.checkLineItemIsGift(item);
                            
                            const effectivePrice = (typeof item.discounted_price === 'number') 
                                ? item.discounted_price 
                                : item.price;

                            if (appliedRuleId) {
                                const giftsOfRule = ruleIdMapGifts.get(appliedRuleId) ?? [];
                                ruleIdMapGifts.set(appliedRuleId, [...giftsOfRule, {
                                    id: itemId,
                                    key: itemKey,
                                    quantity: item.quantity,
                                    price: effectivePrice / ratio
                                }]);
                            } else if (!this.utils.isOtherModuleGift(item)) {
                                itemsInCart.set(itemKey, {
                                    id: itemId,
                                    price: effectivePrice / ratio,
                                    quantity: item.quantity,
                                    title: item.title,
                                    image: item.image,
                                    productId: productId,
                                    selling_plan: !!item.selling_plan_allocation
                                });
                            }
                        }
                    }

                    this.itemsInCart = new Map(itemsInCart);
                    this.ruleIdMapGifts = new Map(ruleIdMapGifts);
                    
                    // Xóa giỏ hàng tạm
                    this.itemsInTempCart.clear();
                    this.ruleIdMapGiftsInTempCart.clear();
                } catch (error) {
                    console.log("Error in custom detectCartData: ", error);
                }
            };
            
            console.log("Salepify Free Gift Override: Installed successfully with discounted_price mapping.");
        }
    }

    installOverride();
    document.addEventListener("DOMContentLoaded", installOverride);
    window.addEventListener("load", installOverride);

    window.addEventListener("pageshow", async function (event) {
        if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
            try {
                await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js?app=salepify', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: {} })
                });

                if (window.tlFreeGiftOffer) {
                    if (typeof window.tlFreeGiftOffer.detectCartData === 'function') {
                        await window.tlFreeGiftOffer.detectCartData();
                    }
                    if (typeof window.tlFreeGiftOffer.updateCartData === 'function') {
                        await window.tlFreeGiftOffer.updateCartData();
                    }
                    window.dispatchEvent(new CustomEvent("TLFREEGIFT:update"));
                }
            } catch (error) {
                console.error("Error syncing cart session on pageshow: ", error);
            }
        }
    });
})();
